import { createUseStyles } from 'react-jss';
import { scrollbar } from '@picsart/design-system/styleUtils/scrollbar';

const useStyles = createUseStyles(
  {
    // Fills its layer, flex or not, and scrolls what does not fit.
    root: {
      flex: 1,
      minHeight: 0,
      height: '100%',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      // Prevent scroll chaining on mobile
      overscrollBehavior: 'contain',
      // The DS scrollbar: themed and thin with a mouse or trackpad, hidden on
      // touch.
      ...scrollbar(),
    },
  },
  { name: 'scroll-panel' }
);

export default useStyles;
